export const loadRecaptchaEnterprise = (siteKey: string) =>
  new Promise<void>((resolve, reject) => {
    if (window.grecaptcha?.enterprise) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject("Failed to load reCAPTCHA");

    document.head.appendChild(script);
  });
